module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/hero_mob-2251111376d73e54594158bb68890f1c.jpg";